import { render } from "./VideoComment.vue?vue&type=template&id=28c9c945"
import script from "./VideoComment.vue?vue&type=script&lang=js"
export * from "./VideoComment.vue?vue&type=script&lang=js"

import "./VideoComment.vue?vue&type=style&index=0&id=28c9c945&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__